// extracted by mini-css-extract-plugin
module.exports = {"nav":"BottomNav_nav__1lHka","nav__menu":"BottomNav_nav__menu__3l4hA","active-route":"BottomNav_active-route__agInp"};